import Vue from 'vue';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import ReferentsApi from '../generated/api/Referents';

export default (service: Servicelayer) => ({
  ...ReferentsApi(service),

  // Add custom calls here

});
